import React, { useEffect, useState, useRef } from "react";
import { observer } from 'mobx-react';
import { Grid, Box, Typography, Skeleton, Alert, CircularProgress, IconButton, Tooltip, Paper, } from "@mui/material";
import Header from "../content/shared/header";
import styles from './my-data.module.scss';
import Footer from "../content/shared/footer";
import FirstTimeModal from "./first-time-modal/first-time-modal";
import { AddCircle, ArrowSquareLeft, ArrowSquareRight, LanguageCircle, } from "iconsax-react";
import RoundButton from "../content/shared/components/round-btn";
import Category from "./category/category";
import LanguageMenu from "./language-menu/language-menu";
import AddInfoMenu from "./add-info-menu/add-info-menu";
import MyDataUiStore from "./my-data-ui-store";
import Primary from '../icons/primary.png';
import ImageCategory from "./category/image-category";
import { Tab, Tabs } from "react-tabs-scrollable";
import Menu from '@mui/material/Menu';
import LanguageMenuDropdown from "./language-menu/language-menu-dropdown";

const uiStore = new MyDataUiStore();

const MyData = observer(({ history, context, location }) => {

    const [showFirstTimeModal, setShowFirstTimeModal] = useState(true);
    const [showLanguageMenu, setShowLanguageMenu] = useState(false);
    const [showLanguageMenuModal, setShowLanguageMenuModal] = useState(false);
    const [showAddInfoMenu, setShowAddInfoMenu] = useState(false);
    const [language, setLanguage] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const { categories, error } = uiStore;
    const [newCategories, setNewCategories] = useState([]);
    const firstNewCategoy = useRef();
    const [start] = useState(0);
    const [selectedTab, setSelectedTab] = useState('Images');
    const [current, setCurrent] = useState(null);
    const [addedNew, setAddedNew] = useState([]);
    const [tabsSize,] = useState(window.innerWidth > 800 ? 6 : 3);
    const [activeTab, setActiveTab] = useState(0);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);


    useEffect(() => {
        const url = new URLSearchParams(location?.search);
        if (!url.entries().next().done) {
            let categoryId = url.get('category');
            const res = categories.find(item => item.name === categoryId);
            const index = categories.findIndex(item => item.name === categoryId);
            setSelectedTab(categoryId);
            setActiveTab(index + 1);
            setCurrent(res);
        }
    }, [categories, history, location?.search]);


    async function fetchData(data = []) {
        uiStore.initliazeContext(context);
        setLoading(true);
        const res = await uiStore.fetchCategories();
        setLanguage(res[0][0]);
        await uiStore.fetchImages();
        setShowFirstTimeModal(!res[1]);
        setLoading(false);
    }

    useEffect(() => {
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context]);

    useEffect(() => {
        if (addedNew) {
            const res = categories.filter(item => addedNew.includes(item.name)).map(item => item.name);
            if (res[0]) {
                const all_categories = categories.map(item => item.name)
                setActiveTab(all_categories.indexOf(res[0]) + 1);
                switchToCategory(res[0])
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addedNew]);


    useEffect(() => {
        if (selectedTab === 'Images') {
            history.push({
                pathname: window.location.pathname,
                search: ''
            })
        } else {

            let allCurrentCategories = categories.map((item, index) => {
                return item.name;
            });
            if (allCurrentCategories.length > 0) {
                if (allCurrentCategories.includes(selectedTab) === false) {
                    setSelectedTab('Images')
                    setActiveTab(0)
                    history.push({
                        pathname: window.location.pathname,
                        search: ''
                    });
                    return;
                }
            }

            history.push({
                pathname: window.location.pathname,
                search: '?category=' + selectedTab
            })
        }
    }, [categories, history, selectedTab, setSelectedTab, setActiveTab]);


    const feedback = () => {
        if (newCategories?.length) {
            var element = document.getElementById(newCategories[0]);
            element?.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
        }
    };


    // define a onClick function to bind the value on tab click
    const onTabClick = (e, index) => {
        setActiveTab(index)
    }

    const switchToCategory = (category) => {
        setLoading(true);
        setSelectedTab(category);
        setCurrent(categories.find(item => item.name === category));
        setLoading(false);
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const buttonClickedHandler = () => {
        setShowLanguageMenuModal((showLanguageMenuModal) => showLanguageMenuModal = !showLanguageMenuModal)
    }

    return (
        <>
            <Header page="my-data"></Header>
            <Grid className='content' container>
                {showFirstTimeModal &&
                    <>
                        {loading ?
                            <CircularProgress sx={{ mt: 2 }} />
                            :
                            <FirstTimeModal setShow={setShowFirstTimeModal} uiStore={uiStore} />
                        }
                    </>
                }
                {!showFirstTimeModal &&
                    <Box className={styles.wrapper}>
                        <Box container className={styles.mydataHeader}>
                            <Grid container className={styles.mydataHeaderContent}>
                                <Grid container item xl={7} lg={7} md={6} sm={6} xs={5} sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                    maxHeight: '75px'
                                }}>
                                    <Grid item xl={3} lg={3} md={4} sm={4.5} xs={12}>
                                        <Typography fontWeight={700} variant="h5" color='#242333'>
                                            My Data
                                        </Typography>
                                    </Grid>
                                    <Grid display={{ sm: 'none', xs: 'block' }} xs={12}
                                        className={styles.mydataHeaderLang} sx={{ mt: 0.7, ml: { xs: 1.5 } }}>
                                        {language?.language}
                                        {language?.primary &&
                                            <img src={Primary} alt="primary language" className={styles.primaryIcon} />
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item xl={5} lg={5} md={6} sm={6} xs={8} className={styles.mydataHeaderActions}
                                    display={{ sm: 'flex', xs: 'none' }}>
                                    <RoundButton
                                        startIcon={
                                            <AddCircle
                                                size="24"
                                                variant="Bulk"
                                            />
                                        }
                                        variant="contained"
                                        sx={{ mr: 1 }}
                                        onClick={() => setShowAddInfoMenu(true)}
                                        className={styles.headerAction}
                                    >
                                        Manage
                                    </RoundButton>
                                    <RoundButton
                                        startIcon={
                                            <LanguageCircle
                                                size="24"
                                                variant="Bulk"
                                            />
                                        }
                                        variant="contained"
                                        color="lightblue"
                                        sx={{ mr: 1 }}
                                        className={styles.headerAction}
                                        id="basic-button"
                                        aria-controls={open ? 'basic-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        onClick={handleClick}
                                    >
                                        {language?.language}
                                        {language?.primary &&
                                            <img src={Primary} alt="primary language" className={styles.primaryIcon} />
                                        }
                                    </RoundButton>

                                    <div>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                            sx={{ p: '20px', top: '20px', right: '20px' }}
                                        >
                                            <LanguageMenuDropdown language={language} setLanguage={setLanguage}
                                                uiStore={uiStore} show={showLanguageMenu}
                                                menuHandleClose={handleClose}
                                                buttonClicked={buttonClickedHandler}
                                                setShow={setShowLanguageMenu} />
                                        </Menu>
                                    </div>
                                </Grid>
                                <Grid item xl={5} lg={5} md={6} sm={6} xs={7} className={styles.mydataHeaderActions}
                                    display={{ sm: 'none', xs: 'flex' }}>
                                    <Tooltip title='Manage'>
                                        <IconButton>
                                            <AddCircle
                                                size="42"
                                                variant="Bulk"
                                                color="#1D1761"
                                                onClick={() => setShowAddInfoMenu(true)}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title='Select Language'>
                                        <IconButton>
                                            <LanguageCircle
                                                size="42"
                                                variant="Bulk"
                                                color="#1D1761"
                                                onClick={handleClick}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Box>

                        {error &&
                            <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                        }

                        {loading ?
                            <>
                                <Skeleton variant="rounded" className={styles.mydataInfoContainer} height={10}
                                    sx={{ mb: 2 }} />
                                <Skeleton variant="rounded" className={styles.mydataInfoContainer} height={10}
                                    sx={{ mb: 2 }} />
                                <Skeleton variant="rounded" className={styles.mydataInfoContainer} height={10}
                                    sx={{ mb: 2 }} />
                            </>
                            :
                            <>
                                <Box className={styles.myDataTabsSticky}>
                                    <Tabs
                                        activeTab={activeTab}
                                        onTabClick={onTabClick}
                                        rightBtnIcon={
                                            <ArrowSquareRight
                                                size="32"
                                                color={(start + tabsSize) >= categories.length ? "#888888" : "#242333"}
                                                variant="Bulk"
                                            />
                                        }
                                        leftBtnIcon={
                                            <ArrowSquareLeft
                                                size="32"
                                                color={start <= 0 ? "#888888" : "#242333"}
                                                variant="Bulk"
                                            />
                                        }
                                        hideNavBtns={false}
                                        hideNavBtnsOnMobile={false}
                                    >
                                        <Tab onClick={() => setSelectedTab('Images')}>Images</Tab>
                                        {categories.map((item) => (
                                            <Tab key={item._id}
                                                onClick={() => switchToCategory(item.name)}>{item.name}</Tab>
                                        ))}
                                    </Tabs>
                                </Box>

                                {selectedTab === 'Images' ?
                                    <>
                                        <Paper sx={{ borderRadius: '16px' }}>
                                            <ImageCategory uiStore={uiStore} />
                                        </Paper>
                                    </>
                                    :
                                    <>
                                        {loading ?
                                            <>
                                                <CircularProgress />
                                            </>
                                            :
                                            <Category
                                                key={current._id}
                                                categoryRef={newCategories?.length && newCategories[0] === current?.infoCategory ? firstNewCategoy : null}
                                                category={current}
                                                editMode={editMode}
                                                setEditMode={setEditMode}
                                                uiStore={uiStore}
                                                language={language}
                                                newlyAdded={newCategories.includes(current?.infoCategory)}
                                                onTabClick={onTabClick}
                                                onDeleteCategory={switchToCategory}
                                            />
                                        }
                                    </>
                                }
                            </>
                        }
                    </Box>
                }
            </Grid>

            <LanguageMenu language={language} setLanguage={setLanguage} uiStore={uiStore} show={showLanguageMenuModal}
                setShow={setShowLanguageMenuModal} />
            <AddInfoMenu show={showAddInfoMenu} setShow={setShowAddInfoMenu} uiStore={uiStore}
                setNewCategories={setNewCategories}
                feedback={feedback}
                setAddedNew={setAddedNew}
                fetchData={fetchData}
            />

            <Footer></Footer>
        </>
    );
});

export default MyData;